import * as React from 'react';
import { Box, Container, Grid, Tooltip } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import { MuiThemeProvider } from '@material-ui/core/styles';
import ReportUserRoles from './Reports/ReportUserRoles';
import ReportUserRoster from './Reports/ReportUserRoster';
import ReportUserRosterConfig from './Reports/ReportUserRosterConfig';
import ReportBillingPO from './Reports/ReportBillingPO';
import ReportBilledPO from './Reports/ReportBilledPO';
import ReportPayroll from './Reports/ReportPayroll';
import BillingHistory from './Reports/BillingHistory';
import UserLogActivity from './Reports/LogActivityPO';
import ReportBillingSOW from './Reports/ReportBillingSOW';
import InvoiceMonthlyReport from './Reports/InvoiceMonthlyReport';
import ExpenseReport from './Reports/ExpenseReport';
import ReportLPCheck from './Reports/ReportLPCheck';
import ReportProjectLP from './Reports/ReportProjectLP';
import ReportTaskHierarchy from './Reports/ReportTaskHierarchy';
import ReportUserTasks from './Reports/ReportUserTasks';
import RateTableReport from './Reports/ReportSOWRateTable'; 
import ReportTimeEntry from './Reports/ReportTimeEntry';
import ReportTimeEntryUnPaid from './Reports/ReportTimeEntryUnPaid';
import ReportAllTimeEntries from './Reports/ReportAllTimeEntries';
import ReportTimeEntryBilled from './Reports/ReportTimeEntryBilled';
import ReportsTimeDelete from './Reports/ReportsTimeDelete'
import { muiThemeDesign } from '../mui-theme-design';
import { makeStyles } from "@mui/styles";
import { Padding, Refresh } from '@mui/icons-material';
import { logger,checkAuthentication} from '../utils';
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            color: '#ffffff'
        },
        "& .MuiButton-root": {
            "@media (min-width: 801px)": {
                fontSize: "0.8rem",
                width: "13rem",
                height: "3rem",
            },
            "@media (max-width: 800px)": {
                fontSize: "1rem",
                width: "10rem",
                height: "6rem",
            },
        },
    },
    indicator: {
        background: "none"
    },
    tabs: {
        "& button[aria-selected='true']": {
            border: "3px solid red"
        }
    },
}));

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
 

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function ReportTabs() {
    const [value, setValue] = React.useState(0);
    const [refresh, setRefresh] = React.useState(true);
    const [refreshDebug, setRefreshDebug] = React.useState(true);
    const classes = pageStyles();
    const [runRoster, setRunRoster] = React.useState(false);
    const [openReport, setOpenReport] = React.useState(true);
    const [propString, setPropString] = React.useState('');

    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState([
        { ID: 0, Email: 'Test@us.beyondsoft.com', Project: 'Project', Lab: "Lab" , PO: "PO", TaskName: "Task", SowName: "SowName"}]);
        
    const [LPAlert, setLPAlert] = React.useState(false);
    const [AppRolesAlert, setAppRolesAlert] = React.useState(false);
    const [POAlert, setPOAlert] = React.useState(false);
    const [ProjectsAlert, setProjectsAlert] = React.useState(false);
    const [TasksAlert, setTasksAlert] = React.useState(false);
 	const [SOWAlert, setSOWAlert] = React.useState(false);
    const [debugMode, setDebugMode] = React.useState(0);
    const [InactiveUsers, SetInactiveUsers] = React.useState(false);
    const [permissions, setPermissions] = React.useState({});
    checkAuthentication();
    
	const handleDebugMode = () => {
		fetch("/api/updateDebug", {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				"DebugMode": debugMode===0?1:0
			})
		}).then(res => res.json())
            .then(json => {
                logger("response from server=", json);
				setDebugMode(json.DebugMode);
			})
		setRefreshDebug(true);
	};

    const handleAlertClose = () => {
        setAlert(false);
    };

    // var propString;
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    const handleRosterCallback = (childData, Expand) => {
             
 //       logger(`roster config callback`, childData);
        SetInactiveUsers(Expand)
        setPropString(childData)      
   //     logger(`PropString`, propString)
        setRunRoster(true)
        setOpenReport(true)
        setRefresh(true)
     //   runReport(propString)
        
       
    };

    const applyAppRoles = async () => {
        await fetch(`/api/Apply_App_Roles`, {
            method: 'POST',
        }).then(res => res.json())
            .then(json => {
                setAlertText(json);
                setAppRolesAlert(true);
                setLPAlert(false);
                setPOAlert(false);
                setProjectsAlert(false);
                setTasksAlert(false);
                setSOWAlert(false);
                logger(json);
            })
        setAlert(true)
    };
    
	const applyLP = async () => {
		await fetch(`/api/Apply_LP`, {
			method: 'POST',
		}).then(res => res.json())
			.then(json => {
				setAlertText(json)
				setAppRolesAlert(false);
                setLPAlert(true);
                setPOAlert(false);
                setProjectsAlert(false);
                setTasksAlert(false);
                setSOWAlert(false);
                logger(json);
			})
		setAlert(true)
	};

	const applyProjects = async () => {
		await fetch(`/api/Apply_Projects`, {
			method: 'POST',
		}).then(res => res.json())
			.then(json => {
				setAlertText(json)
				setAppRolesAlert(false);
                setLPAlert(false);
                setPOAlert(false);
                setProjectsAlert(true);
                setTasksAlert(false);
                setSOWAlert(false);
				logger(json);
			})
		setAlert(true)
	};
	
	const applyPO = async () => {
		await fetch(`/api/Apply_PO`, {
			method: 'POST',
		}).then(res => res.json())
			.then(json => {
				setAlertText(json)
				setAppRolesAlert(false);
                setLPAlert(false);
                setProjectsAlert(false);
                setPOAlert(true);
                setTasksAlert(false);
                setSOWAlert(false);
                logger(json)
			})
		setAlert(true)
	};
	
	const applySOW = async () => {
		await fetch(`/api/Apply_SOW`, {
			method: 'POST',
		}).then(res => res.json())
			.then(json => {
				setAlertText(json)
				setAppRolesAlert(false);
                setLPAlert(false);
                setProjectsAlert(false);
                setPOAlert(false);
                setTasksAlert(false);
                setSOWAlert(true);
                logger(json)
			})
		setAlert(true)
	};
	
	const applyTasks = async () => {
		await fetch(`/api/Apply_Tasks`, {
			method: 'POST',
		}).then(res => res.json())
			.then(json => {
				setAlertText(json)
				setAppRolesAlert(false);
                setLPAlert(false);
                setProjectsAlert(false);
                setPOAlert(false);
                setTasksAlert(true);
                logger(json)
			})
		setAlert(true)
	};

    const handleClearRoster = () => {

   //      logger(`ClearRoster`);
        setOpenReport(false)
        setPropString('')
        setRunRoster(false)
        setRefresh(false)

        //   runReport(propString)


    };
    function runReport(propString) {
        setOpenReport(true)
    //    logger(`checkString`, propString)
    //    logger(`checkRun`, runRoster)
       setRefresh(false)
   //     ReportUserRoster(propString)
    }

    React.useEffect(() => {
 //       logger(`useEffect RunR`, runRoster)
 //       logger(`useEffect Refrsh`, refresh)
 //       logger(`useEffect String`, propString)
     
        if (refresh) {
            if (runRoster) {

                logger(`refresh reportTab`, propString)
                runReport(propString)
            }
            fetch('/api/User/Permission')
	            .then(res => res.json())
	            .then(json => setPermissions(json))
                .then(json => logger(`userTab Permissions in Reports.tsx- `, json))
        }
        setRefresh(false);
     //   setRunRoster(false)
     
     if(refreshDebug){
		 fetch('/api/getDebug')
	            .then(res => res.json())
	            .then(json => setDebugMode(json.DebugMode))
	    setRefreshDebug(false);
	 }
    })

    // variant="fullWidth"
    return (
        <MuiThemeProvider theme={muiThemeDesign}>
            {(runRoster) ? <ReportUserRoster handleClearRoster={handleClearRoster} openReport={openReport} newRoster={runRoster} InactiveUsers={InactiveUsers} data={propString} /> : <></>}

            <Box sx={{ width: '100%' }}>
                <Box className={classes.root} sx={{ borderBottom: 1, borderColor: 'divider'}}>
                    <Tabs  value={value} onChange={handleChange} aria-label="ReportsTab"  sx={{paddingTop: 8}}>
                        <Tab label="Users" {...a11yProps(0)} />
                        <Tab label="Time/Billing" {...a11yProps(1)} />
                        <Tab label="Site Mgt" {...a11yProps(2)} />
                        <Tab label="Clean Up" {...a11yProps(3)} />                 
                    </Tabs>
                </Box>

                <TabPanel className={classes.root} value={value} index={0}>
                    <MuiThemeProvider theme={muiThemeDesign}>
                        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 4, md: 8, lg:10, xl:12 }}>
                            <Grid item xs={2}>
                                <ReportUserRoles />
                            </Grid>
                            <Grid item xs={2}>
                                <ReportUserRosterConfig handleRosterCallback={handleRosterCallback} />
                            </Grid>
                            <Grid item xs={2}>
                                <ReportUserTasks />
                            </Grid>
                        </Grid>
                    </MuiThemeProvider>
                </TabPanel>
              
                <TabPanel className={classes.root} value={value} index={1}>
                    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 4, md: 8, lg:10, xl:12 }}>
                       {permissions.ViewFinancials===1 && 
                       	<Grid item xs={2}>
                            <ReportBillingPO />
                        </Grid>}
                        {permissions.ViewFinancials===1 && 
                        <Grid item xs={2}>
                            <ReportBilledPO />
                        </Grid>}
                        {permissions.ViewFinancials===1 && 
                        <Grid item xs={2}>
                            <BillingHistory />
                        </Grid>}
                        <Grid item xs={2}>
                            <ReportTimeEntry />
                        </Grid>
                        <Grid item xs={2}>
                            <ReportTimeEntryBilled />
                        </Grid>
                         <Grid item xs={2}>
                            <ReportTimeEntryUnPaid />
                        </Grid>
                        <Grid item xs={2}>
                            <ReportAllTimeEntries />
                        </Grid>
                        <Grid item xs={2}>
                            <ReportsTimeDelete />
                        </Grid>
                        <Grid item xs={2}>
                            <ReportPayroll />
                        </Grid>
                        <Grid item xs={2}>
                            <ReportLPCheck />
                        </Grid>
                       {permissions.ViewFinancials===1 && 
                        <Grid item xs={2}>
                            <ReportBillingSOW />
                        </Grid>}
                        {permissions.ViewFinancials===1 && 
                         <Grid item xs={2}>
                            <InvoiceMonthlyReport />
                        </Grid>}
                        {permissions.ViewFinancials===1 && 
                         <Grid item xs={2}>
                            <ExpenseReport/>
                        </Grid>}
                    </Grid>
                </TabPanel>
                <TabPanel className={classes.root} value={value} index={2}>
                    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 4, md: 8, lg:10, xl:12 }}>
                        <Grid item xs={2}>
                            <ReportProjectLP />
                        </Grid>
                        <Grid item xs={2}>
                            <ReportTaskHierarchy />
                        </Grid>
                        {permissions.ViewFinancials===1 && 
                        <Grid item xs={2}>
                            <RateTableReport />
                        </Grid>}
                        <Grid item xs={2}>
                            <UserLogActivity />
                        </Grid>
                        <Grid item xs={2}>
                            <Button variant="contained" onClick={handleDebugMode}>DebugMode Switched {debugMode===1 ? "ON" : "OFF"}</Button>
                        </Grid>
                    </Grid>
			    </TabPanel>
				<TabPanel className={classes.root} value={value} index={3}>
                    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 4, md: 8, lg:10, xl:12 }}>
                        <Grid item xs={2}>
                            <Tooltip title="Deactivating L&P based on EndDate < current date">
                                <Button variant="contained" onClick={applyLP}>
                                    Cleanup L&P
                                </Button>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={2}>
                            <Tooltip title="Deactivating PO's based on EndDate < current date">
                                <Button variant="contained" onClick={applyPO}>
                                    Cleanup PO
                                </Button>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={2}>
                            <Tooltip title="Deactivating SOW's based on EndDate < current date">
                                <Button variant="contained" onClick={applySOW}>
                                    Cleanup SOW
                                </Button>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={2}>
                            <Tooltip title="Deactivating Projects based on EndDate < current date">
                                <Button variant="contained" onClick={applyProjects}>
                                    Cleanup Projects
                                </Button>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={2}>
                            <Tooltip title="Deactivates tasks that are either part of inactive projects, associated with inactive L&Ps, or having missing projects">
                                <Button variant="contained" onClick={applyTasks}>
                                    Cleanup Tasks
                                </Button>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={2}>
                            <Tooltip title="Sets UserRole = BasicUser when User with no role">
                                <Button variant="contained" onClick={applyAppRoles}>
                                    Cleanup App Roles
                                </Button>
                            </Tooltip>
                        </Grid>
                    </Grid>				       
				</TabPanel>
			</Box>
            <Dialog
                open={LockedAlert}
                onClose={handleAlertClose}
                aria-labelledby="L&P Lock"
                aria-describedby="Time Period locked for this work"
            >
                <DialogTitle id="Time Entry">
                    {AppRolesAlert && "Creates UserRoles When User doesnt have UserRole"}
                    {LPAlert && "De-Activated L&Ps due to Expired Dates "}
                    {ProjectsAlert && "De-Activated Projects due to Expired Dates "}
                    {POAlert && "De-Activated PO's due to Expired Dates "}
                    {TasksAlert && "De-Activated Tasks due to Expired Dates "}
                    {SOWAlert && "De-Activated SOW due to Expired Dates "}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                       
                        {AppRolesAlert && AlertText.map((row) => { return (<p>{row.Email}</p>) })}
                        {LPAlert && AlertText.map((row) => { return (<p>{row.Project + '-' + row.Lab}</p>) })}
                        {ProjectsAlert && AlertText.map((row) => { return (<p>{row.Project}</p>) })}
                        {POAlert && AlertText.map((row) => { return (<p>{row.PO}</p>) })}
                        {TasksAlert && AlertText.map((row) => { return (<p>{row.TaskName}</p>) })}
                        {SOWAlert && AlertText.map((row) => { return (<p>{row.SowName}</p>) })}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setAlert(false) }} autoFocus>OK</Button>
                </DialogActions>
            </Dialog>
        </MuiThemeProvider>
    );
}